import { PageController } from '@client/components/_core/layout/PageController';
import { StringListSetting } from '@client/components/_core/settings/StringListSetting';
import {
    coiUploadDocumentTypesSetting,
    complaintUploadDocumentTypesSetting,
    incidentUploadDocumentTypesSetting,
} from '@shared/schemas/org-settings';
import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/general/documents')({
    staticData: {
        metadata: {
            title: 'Document types',
        },
        ui: {
            icon: FileText,
            title: 'Document types',
            subtitle: 'Upload document types for complaints, incidents and conflicts of interest',
            menuDescription: 'Upload document types for complaints, incidents and conflicts of interest',
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <StringListSetting
                    definition={complaintUploadDocumentTypesSetting}
                    icon={FileText}
                    title="Complaint document types"
                    noun="document type"
                />
                <StringListSetting
                    definition={incidentUploadDocumentTypesSetting}
                    icon={FileText}
                    title="Incident document types"
                    noun="document type"
                />
                <StringListSetting
                    definition={coiUploadDocumentTypesSetting}
                    icon={FileText}
                    title="Conflict of interest document types"
                    noun="document type"
                />
            </div>
        </PageController>
    );
}
